import * as React from "react"
import { styled } from "../stitches.config"
import { linkStyle } from "./Link"

const A = styled("a", linkStyle)

export default A
